<template>
  <section
    class="w-[280px] overflow-hidden rounded-8 bg-bg-base-bg1 shadow-card"
    data-test="message-views-viewer"
  >
    <div class="p-1">
      <button
        type="button"
        data-test="message-views-viewer-back"
        class="box-border flex h-9 w-full cursor-pointer items-center gap-1 rounded-8 px-2 text-body-r-14-20 text-fg-base-fg3 hover:bg-surf-neut-soft-hov"
        @click="emit('back')"
      >
        <wui-icon
          name="chevronLeftLgM"
          class="shrink-0"
        />
        <span>{{ $t('common.back') }}</span>
      </button>
    </div>
    <hr class="mx-2 border-t border-bor-nav">

    <ul class="max-h-[320px] overflow-y-auto px-1 py-2">
      <li
        v-for="viewer in viewers"
        :key="viewer.contactId"
      >
        <reaction-list-item
          :author="viewer.contactId"
          :timestamp="viewer.timestamp"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { ReactionListItem } from '@/entities/reaction'
import { useStoreLastReadEventIds } from '@/entities/room'

const props = defineProps<{
  eventId: number
  pServed: string
}>()

const emit = defineEmits<{
  (event: 'back'): void
}>()

const lastReadStore = useStoreLastReadEventIds()
const {
  lastMessageEventIdByRoomAndContactId,
  readTimestampsByMessageEventId,
} = storeToRefs(lastReadStore)
const { getViewersByMessageEventId } = lastReadStore

const viewers = computed(() => {
  void lastMessageEventIdByRoomAndContactId.value[props.pServed]
  void readTimestampsByMessageEventId.value
  return getViewersByMessageEventId(props.pServed, props.eventId)
})
</script>
